module.exports = __webpack_public_path__ + "static/media/fly0064.e8e502ca.webp";